module.exports = __webpack_public_path__ + "media/images/brands/marque-kerastase-8656d547f280ce84bde96c0db016ada0.jpg";